import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageHeader from "components/pageHead/pageHead";
import { commonChips } from "constants/common/pageHeaderChips";
import { nearMissForm } from "constants/forms/newNearMissForm";
import FieldsGetter from "components/fields/fields";
import styles from './newNearMiss.module.css'
import { Chip, Stack } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Button } from "antd";
import { Validate } from "utils/validation/validate";
import { AlertState } from "schemas";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { Confirmation } from "schemas";
import Layout from "components/LayoutContainers/mainLayout";
import { GeneralFetch } from "Api/generalFetch/generalFetch";
import LinearProgressComponent from "components/linearProgress/linearProgress";
import { classNames } from "primereact/utils";
import { getUsers } from "hooks/users/getUsers";
import { createDrawerState, DrawerSchema } from "schemas";
import { userData } from "schemas";
import { locais } from "schemas";
import { getLayoutByDevice } from "hooks/mobileCheck/useCheckMobile";

function NewNearMiss() {
    const user = useRecoilValue(userData)
    const navigate = useNavigate();
    const [selected, setSelected] = useState('nearmisses')
    const [formData, setFormData] = useState({ reportado_por: "" })
    const setAlert = useSetRecoilState(AlertState)
    const [confirmation, setOpenConfirm] = useRecoilState(Confirmation)
    const { fetchData, loading } = GeneralFetch()
    const { users, loading: loadingUsers } = getUsers()
    const [open, setOpen] = useRecoilState(DrawerSchema)
    const locations = useRecoilValue(locais)
    const verticalLayout = getLayoutByDevice();

    useEffect(() => {
        if (open?.update == true) {
            setSelected(open?.object)
            setFormData({ ...open?.data })
        }
    }, [])

    useEffect(() => {
        if (open?.update != true) {
            console.log(open?.update)
            setFormData({
                reportado_por: Number(user.id),
                dataAcontecimento: new Date().toString(),
                local_reporter: users?.find(x => x.value == user.id)?.local
            })
        }
    }, [users, selected])

    useEffect(() => {
        const reporter = formData?.reportado_por
        if (reporter && open?.update != true) setFormData(prev => ({ ...prev, local_reporter: users?.find(x => x.value == reporter)?.local }))
    }, [formData?.reportado_por])

    const disabled = () => {
        if (user.acesso == '1' || open?.data?.reportado == user.id) return true
        else return open?.update == true
    }

    useEffect(() => {
        const fetchDataAsync = async () => fetchData(
            {
                ...formData,
                tipoReporte: selected,
                ...(open?.update == true ? {} : { regrasDeOuro: open?.rules ?? [] }),
                ...(formData?.reportado_por ? {} : user?.acesso == '1' ? { reportado_por: user.id } : {}),
                dataAcontecimento: new Date(formData?.dataAcontecimento)
            },
            open?.update == true ? `updateNearMiss/${open?.data?.objectId}` : 'newNearMiss',
            open?.update == true ? 'put' : 'post',
            ''
        )

        if (confirmation.confirmed == true && confirmation?.component == "create") {
            const valid = Validate(formData, selected)
            if (valid === true) {
                void fetchDataAsync().then((resp) => {
                    setOpenConfirm({})
                    if (resp?.data) {
                        if (verticalLayout) {
                            navigate("/mobile-home?success=true");
                        } else {
                            setOpen(createDrawerState({ open: true, object: selected, data: { estado: "1", ...resp?.data } }))
                        }

                        if (open?.update != true) {
                            setFormData(() => ({
                                reportado_por: Number(user.id),
                                dataAcontecimento: new Date().toString(),
                                local_reporter: users?.find(x => x.value == user.id)?.local
                            }))
                        }
                    }
                })
            } else setAlert(alert => ({ ...alert, type: 'warning', msg: `Por favor, preencha o campo - ${valid}` }))
        }

    }, [confirmation.confirmed])

    const onChange = (id, value) => setFormData((prevValues) => ({ ...prevValues, [id]: value }))

    function bubleClick(value, id) {
        const bubleValues = typeof formData?.[id] == 'string' ? JSON.parse(formData?.[id]) : formData?.[id]

        if (formData && (bubleValues?.includes(value) || bubleValues?.includes(Number(value)))) {
            let deleted = [...bubleValues].filter(x => x != value)

            setFormData((prevValues) => ({
                ...prevValues, [id]: [...deleted]
            }))
        } else {
            setFormData((prevValues) => ({
                ...prevValues, [id]: [
                    ...(bubleValues || []),
                    value
                ]
            }))
        }
    }

    const submit = (msg) => setOpenConfirm({
        component: "create",
        open: true,
        msg: msg ?? `Tem certeza que deseja ${open?.update == true ? 'actualizar' : 'reportar'}  esse ` + commonChips.find(chip => chip.value === selected).label.toString().toLowerCase() + " ?"
    })

    // Função para obter estilos baseados no layout
    const getFieldContainerStyle = (field) => {
        if (verticalLayout) {
            return { marginBottom: "25px", width: "100%" }
        }
        return {}
    }

    const getFieldClassName = (field) => {
        if (verticalLayout) {
            return ""
        }
        return field.flex ? styles.item : styles.itemNoFlex
    }

    const getLabelStyle = (field) => {
        if (verticalLayout) {
            return { marginBottom: "8px" }
        }
        return {}
    }

    const getInputWidth = (field) => {
        if (verticalLayout) {
            return "100%"
        }
        return field.flex ? "70%" : "85%"
    }

    return (
        <Layout>
            <PageHeader disabled={open?.update} selected={selected} setSelected={setSelected} chips={commonChips} setFormData={setFormData} formData={formData} />

            <Grid container marginTop={"0px"} spacing={6}>
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={0}
                            px={0}
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                        >
                            {(loading || loadingUsers) && <LinearProgressComponent />}
                            <div style={{ margin: "20px 10px" }} >
                                <MDTypography variant="h6" color="white" >
                                    {commonChips.find(chip => chip.value === selected).label}
                                </MDTypography>
                            </div>
                        </MDBox>
                        <MDBox p={2.5} >
                            <span className={styles.pageTitle} >Os campos com <span className={styles.required} >*</span> mostram obrigatoriedade de preenchimento</span>
                            <div className={classNames(styles.container, (loading || loadingUsers) && styles.disabled)} >

                                {
                                    nearMissForm(users, disabled(), locations)?.map((field) => {
                                        const { label, ...other } = field

                                        switch (field.type) {
                                            case 'bubles':
                                                const arrayValues = typeof formData?.[field.fieldId] == 'string' ? JSON.parse(formData?.[field.fieldId]) : formData?.[field.fieldId]

                                                return (
                                                    <div style={{ marginBottom: "15px" }}>
                                                        <div>
                                                            <MDTypography variant="h6" color="dark">
                                                                {field.label}<span className={styles.required} >{field.required && " *"}</span>
                                                            </MDTypography>
                                                            <label className={styles.note} >{field.note}</label>
                                                        </div>
                                                        <div>
                                                            {
                                                                field.sections.map((bubleSection) => {
                                                                    return (
                                                                        <div className={styles.bubles} style={verticalLayout ? {} : { display: "flex", flexWrap: "wrap" }}>

                                                                            <label className={styles.categorias} >
                                                                                {bubleSection.description}
                                                                            </label>

                                                                            <Stack direction="row" rowGap={1} flexWrap="wrap" spacing={1}>
                                                                                {
                                                                                    bubleSection.bubles.map((chip) => {
                                                                                        return <Chip
                                                                                            size="medium"
                                                                                            style={{
                                                                                                fontSize: "15px",
                                                                                                ...((arrayValues?.includes(Number(chip.value)) || arrayValues?.includes(chip.value)) ? { background: "#72DDF7" } : { opacity: 0.6 })
                                                                                            }}
                                                                                            label={chip.label}
                                                                                            onClick={() => { bubleClick(chip.value, field.fieldId) }}
                                                                                        />
                                                                                    })
                                                                                }
                                                                            </Stack>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                )

                                            case "table":
                                                return (
                                                    <div style={verticalLayout ? { marginBottom: "25px", width: "100%" } : {}} className={!verticalLayout ? (field.flex ? styles.item : styles.itemNoFlex) : ""} >
                                                        <div style={verticalLayout ? { marginBottom: "10px" } : {}} className={!verticalLayout ? styles.label : ""} >
                                                            <MDTypography variant="h6" color="dark">
                                                                {field.title}<span className={styles.required} >{field.required && " *"}</span>
                                                            </MDTypography>
                                                        </div>
                                                        <div style={{ width: getInputWidth(field) }} >
                                                            <table style={verticalLayout ? { width: "100%" } : {}}>
                                                                <thead>
                                                                    {
                                                                        ["", ...field.cols].map((head) => <th className={styles.categorias} >{head.label}</th>)
                                                                    }
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        field.rows.map((row) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td className={styles.categorias} >{row.label}</td>
                                                                                    {
                                                                                        field.cols.map((input) => {

                                                                                            return (
                                                                                                <td style={{ padding: "7px" }}  >
                                                                                                    <FieldsGetter props={{
                                                                                                        ...field,
                                                                                                        label: input.label,
                                                                                                        type: field.inputType,
                                                                                                        formData,
                                                                                                        onChange,
                                                                                                        setFormData,
                                                                                                        disabled: (`${row.id}_${input.id}`).includes('total'),
                                                                                                        fieldId: `${row.id}_${input.id}`,
                                                                                                    }} />
                                                                                                </td>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                )

                                            case "inputGroup":
                                                return (
                                                    <>
                                                        <MDTypography variant="h6" color="dark">
                                                            {field.label} <span className={styles.required} >{field.required && " *"}</span>
                                                        </MDTypography>
                                                        <div style={verticalLayout ? { marginBottom: "25px", width: "100%" } : {}} className={!verticalLayout ? (field.flex ? styles.item : styles.itemNoFlex) : ""} >
                                                            <div style={{ width: verticalLayout ? "100%" : "100%" }} >
                                                                {
                                                                    field.groups.map((group) => {
                                                                        return (
                                                                            <>
                                                                                <div style={verticalLayout ? { marginBottom: "15px" } : { marginBottom: "30px" }} className={!verticalLayout ? styles.label : ""} >
                                                                                    <MDTypography variant="h6" color="dark">
                                                                                        {group.title}
                                                                                    </MDTypography>
                                                                                </div>
                                                                                <div>
                                                                                    {
                                                                                        group.fields.map((field) => {
                                                                                            const { label, ...other } = field

                                                                                            return (
                                                                                                <div style={verticalLayout ? { marginBottom: "20px", width: "100%" } : {}} className={!verticalLayout ? (field.flex ? styles.item : styles.itemNoFlex) : ""} >
                                                                                                    <div style={verticalLayout ? { marginBottom: "8px" } : {}}>
                                                                                                        <label className={styles.categorias} >
                                                                                                            {label}<span className={styles.required} >{field.required && " *"}</span>
                                                                                                        </label>
                                                                                                    </div>
                                                                                                    <div style={{ width: getInputWidth(field) }} >
                                                                                                        <FieldsGetter props={{
                                                                                                            ...other,
                                                                                                            label,
                                                                                                            formData,
                                                                                                            onChange,
                                                                                                            setFormData,
                                                                                                            width: '100%'
                                                                                                        }} />
                                                                                                    </div>
                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                    }
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            default:
                                                return (
                                                    <div style={getFieldContainerStyle(field)} className={getFieldClassName(field)} >
                                                        <div style={getLabelStyle(field)} className={!verticalLayout ? styles.label : ""} >
                                                            <MDTypography variant="h6" color="dark">
                                                                {label}<span className={styles.required} >{field.required && " *"}</span>
                                                            </MDTypography>
                                                        </div>
                                                        <div style={{ width: getInputWidth(field) }} >
                                                            <FieldsGetter props={{
                                                                ...other,
                                                                label,
                                                                formData,
                                                                onChange,
                                                                setFormData,
                                                                width: '100%'
                                                            }} />

                                                            {
                                                                field.colapse && (
                                                                    <Accordion style={{ position: formData?.[field.fieldId] == 1 ? "relative" : "absolute" }} elevation={1} expanded={formData?.[field.fieldId] == 1} >
                                                                        <div>
                                                                            {formData?.[field.fieldId] == 1 && <AccordionDetails>
                                                                                <div style={{ marginBottom: "10px" }} >
                                                                                    <MDTypography fontWeight="regular" variant="h6" color="dark">
                                                                                        {field.colapseInput.label}<span className={styles.required} >{field.colapseInput.required && " *"}</span>
                                                                                    </MDTypography>
                                                                                </div>
                                                                                <FieldsGetter props={{
                                                                                    ...field.colapseInput,
                                                                                    onChange,
                                                                                    setFormData,
                                                                                    formData,
                                                                                    width: '100%'
                                                                                }} />
                                                                            </AccordionDetails>}
                                                                        </div>
                                                                    </Accordion>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                        }
                                    })
                                }

                            </div>
                            <Stack className={loading && styles.disabled} direction="row" spacing={1} style={{ margin: "10px" }} >
                                <Button type="primary" onClick={() => submit()} >{open?.update ? 'Actualizar' : 'Reportar'}</Button>

                                <Button type="primary" danger>Cancelar</Button>
                            </Stack>
                        </MDBox>
                    </Card>
                </Grid>
            </Grid>
        </Layout >
    );
}

export default NewNearMiss;
